import NavBar from "../navbar/NavBar";
import Sidebar from "../sidebar/Sidebar";

export default function ReportPageShell({ title, children }) {
  return (
    <div className="ReportPageShell">
      <div className="LandingContainer" style={{ overflow: "hidden" }}>
        <NavBar />
        <Sidebar />
        <div className="PageContent">
            {title && (
              <div className="reportTitle" style={{ paddingBottom: "5px" }}>
              <h1>{title}</h1>
              </div>
            )}
            {children}
        </div>
      </div>
    </div>
  );
}
